import React from 'react'
import { Card } from 'react-bootstrap'



const PostCard = ({ post }) => {
    return (
        <a href={post.link} rel="noreferrer" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Card style={{ width: '16rem', borderRadius: '15px', height: '290px' }} className='shadow-sm'>
                <Card.Img variant="top" style={{ borderRadius: '15px', width: '100%', height: '180px', borderBottomLeftRadius: '0', borderBottomRightRadius: '0' }} src={post.thumbnail} className='shadow-lg' />
                <Card.Body className='text-center'>
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Text>
                        {post.desc}
                    </Card.Text>
                </Card.Body>
            </Card>
        </a>
    )
}

export default PostCard
